export const CALL_TO_ACTION = 'call-to-action';